/**
 * In-memory token holder. Access AND refresh tokens live ONLY in JS memory
 * (module state) — never in localStorage, sessionStorage, cookies or IndexedDB.
 * A full page reload therefore drops the session and forces a re-login. This is
 * an accepted MVP trade-off.
 *
 * FUTURE: replace the refresh-token half of this with a server-set httpOnly,
 * Secure, SameSite cookie so the SPA can silently refresh across reloads without
 * ever exposing the refresh token to JavaScript.
 */
export interface TokenHolder {
  getAccessToken(): string | null;
  getRefreshToken(): string | null;
  set(tokens: { accessToken: string; refreshToken: string }): void;
  clear(): void;
}

export function createTokenHolder(): TokenHolder {
  let accessToken: string | null = null;
  let refreshToken: string | null = null;

  return {
    getAccessToken: () => accessToken,
    getRefreshToken: () => refreshToken,
    set: (tokens) => {
      accessToken = tokens.accessToken;
      refreshToken = tokens.refreshToken;
    },
    clear: () => {
      accessToken = null;
      refreshToken = null;
    },
  };
}

/** Default process-wide holder used by the real API client. */
export const tokenHolder: TokenHolder = createTokenHolder();
